
import { defineComponent } from "vue";
import GameService from "../../../services/GameService";
import ResponseData from "../../../_models/ResponseData";
import { Helper } from "../../../utils/Helper";
import store from '@/store/index'
import GamesGalleryComponent from "../components/tabGamePage/gallery/gamesGalleryComponent.vue";

export default defineComponent({
    data() {
        return {
            // maxStep: 0,
            stepCount: 0,
            userData: store.getters["auth/user"] ?? "",
            coverImage: "",
            gameDetails: [],
            about: "",
            username: "",
            gallery: [],
            languages: [],
        };
    },
    methods: {
        getGameDetails() {
            if (this.$route.params.gameId !== undefined && this.userData !== "") {
                let gameId = this.$route.params.gameId.toString();
                GameService.getGame(gameId)
                    .then((response: ResponseData) => {
                    if (response.status === 200) {
                        this.gameDetails = response.data.viewModel.game;
                        this.username = this.userData.username;
                        this.gameDetails.created = Helper.formatDate(this.gameDetails.created);
                        this.gameDetails.updated = Helper.formatDate(this.gameDetails.updated);
                        if (response.data.viewModel.details !== null && response.data.viewModel.details.about !== null) {
                            this.about = response.data.viewModel.details.about.about;
                        }
                        if (response.data.viewModel.details !== null && response.data.viewModel.details.gallery.headerImage !== null) {
                            this.coverImage = this.assetUrl + "blob/games/" + gameId + "/gallery/" + response.data.viewModel.details.gallery.headerImage;
                        }
                        if (response.data.viewModel.details !== null && response.data.viewModel.details.gallery.galleryImages !== []) {
                            response.data.viewModel.details.gallery.galleryImages.forEach((image, index) => {
                                this.gallery.push({
                                    id: index + 1,
                                    url: this.assetUrl + "blob/games/" + gameId + "/gallery/" + image,
                                    itemCount: index + 1,
                                    display: index > 2 ? false : true,
                                });
                            });
                        }
                        // this.maxStep = this.gallery.length <= 3 ? 0 : Math.floor(this.gallery.length / 3);
                        // this.gallery = this.groupGalleryByThree(this.gallery);
                    }
                })
                    .catch((error) => {
                    Helper.endpointErrorHandling(error);
                });
            }
        },
    },
    computed: {
        testnetLabel() {
            return store.getters["config/configTestnetLabel"];
        },
        assetUrl() {
            return store.getters["config/assetUrl"];
        },
    },
    mounted() {
        this.getGameDetails();
    },
    name: "viewGamesPreview",
    components: {GamesGalleryComponent }
});
